import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable()
export class ErrorLanguageInterceptor implements HttpInterceptor {
  constructor(private translateService: TranslateService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const activeLang = this.translateService.currentLang;
    const culture = toAspNetCulture(activeLang);

    const modifiedReq = req.clone({
      setHeaders: {
        'X-Language': culture,
      },
    });

    return next.handle(modifiedReq);
  }
}

function toAspNetCulture(translocoLang: string): string {
  const mappings: Record<string, string> = {
    en: 'en-US',
    pl: 'pl-PL',
    de: 'de-DE',
    fr: 'fr-FR',
    nl: 'nl-NL',
    es: 'es-ES',
    pt: 'pt-BR',
    ru: 'ru-RU',
    zh: 'zh-CN',
    ja: 'ja-JP',
  };

  return mappings[translocoLang] || 'en-US';
}
